import { render, staticRenderFns } from "./associateIndividualsForm.vue?vue&type=template&id=1b970fa8"
import script from "./associateIndividualsForm.vue?vue&type=script&lang=js"
export * from "./associateIndividualsForm.vue?vue&type=script&lang=js"
import style0 from "./associateIndividualsForm.vue?vue&type=style&index=0&id=1b970fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports